export enum TextTrackSurfaceEvents  {
    METADATA_CUEPOINT = 'metadataCuepoint',
    TEXT_CUEPOINT = 'textCuepoint',
    TEXT_TRACK_DISPLAY_MODE_CHANGE = 'textTrackModeChange',
    TEXT_TRACK_ADDED = 'textTrackAdded',
    TEXT_TRACK_CHANGE = 'textTrackChange',
    TEXT_TRACK_AVAILABLE = 'textTrackAvailable'
}